/**
 * Activate TOC links as page is scrolled.
 */
(function() {
  const toc = document.querySelector('.js-toc');
  const targets = Object.fromEntries(Array.from(document.querySelectorAll('.js-toc-target')).map(el => [el.id, { el: el, ratio: 0 }]));
  let activeTargetId;

  const callback = entries => {
    entries.forEach(entry => {
      targets[entry.target.id].ratio = entry.intersectionRatio;
    });
    const newActiveTargetId = Object.values(targets).sort((a, b) => b.ratio - a.ratio)[0].el.id;
    if (newActiveTargetId !== activeTargetId) {
      toc.querySelector(`[href="#${activeTargetId}"]`)?.classList.remove('active');
      toc.querySelector(`[href="#${newActiveTargetId}"]`).classList.add('active');
      activeTargetId = newActiveTargetId;
    }
  };
  const options = {
    threshold: [.5, 1],
  };

  const observer = new IntersectionObserver(callback, options);
  Object.values(targets).forEach(target => observer.observe(target.el));
})();


/**
 * Target TOC links together with TOC subjects.
 */
(function() {
  const toc = document.querySelector('.js-toc');
  const updateToc = hash => {
    toc.querySelector('.targeted')?.classList.remove('targeted');
    toc.querySelector(`[href="${hash}"]`).classList.add('targeted');
  };

  if (location.hash) updateToc(location.hash);
  window.addEventListener('hashchange', () => updateToc(location.hash));
})();
